import { CustomerDeliveryNoteSigningComponent } from './customer-delivery-note-signing-dialog/customer-delivery-note-signing-dialog.component';
import { CommonModule } from '@angular/common';
import { CustomerInvoiceCreationDialogComponent } from './customer-invoice-creation-dialog/customer-invoice-creation-dialog.component';
import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbDropdownModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import {
  AfterViewInit,
  Component,
  computed,
  inject,
  Injector,
  OnInit,
  signal,
  Signal,
  ViewChild,
} from '@angular/core';
import {
  CreateUpdateCustomerDeliveryNoteDto,
  CustomerDeliveryNoteDto,
  CustomerDeliveryNoteService,
  CustomerDeliveryNoteSigningService,
  CustomerDocDefaultValueDto,
  CustomerInvoiceDto,
  CustomerInvoiceService,
  DayBookDto,
  DayBookService,
  DocHierarchyDto,
  InvoicedStatus,
} from '@digiwall/goliath-documents/proxy';
import { concatMap, Observable, of } from 'rxjs';
import { CustomerService, PointOfSaleService } from '@digiwall/goliath-contacts/proxy';
import { GoliathContactsEnumerationTypeStore, SalesPersonStore } from '@digiwall/goliath-contacts';
import {
  AnnexesListComponent,
  CurrentCompanyStore,
  GoliathCoreEnumerationTypeStore,
} from '@digiwall/goliath-core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ConfigStateService,
  LocalizationService,
  SubscriptionService,
  LocalizationModule,
} from '@abp/ng.core';
import { FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ClassificationTypeService, DocRole, WeightUnit } from '@digiwall/goliath-core/proxy';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';
import { CustomerDeliveryNoteLinesEditorComponent } from './customer-delivery-note-lines/customer-delivery-note-lines-editor.component';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { ReportViewerComponent } from '@odyssey/reporting';
import { BaseCustomerDocDetail } from '../../base-customer-docs/base-customer-doc-detail';
import { FieldMapping } from '../../base-third-party-docs/base-third-party-doc-detail';
import {
  ChatComponent,
  DeactivatableComponentService,
  DwEnumSelectDirective,
  HistoryComponent,
  OdysseyOffcanvas,
} from '@digiwall/core';
import {
  CustomerDeliveryNotePermission,
  DocReportPermission,
} from '@digiwall/goliath-documents/config';
import {
  CounterComponent,
  DropdownMenu,
  PanelComponent,
  DropdownMenuComponent,
  PanelTrigger,
} from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import { DwNavLinkDirective } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwKeyboardShortcutDirective } from '@digiwall/core';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { DocConditionsComponent } from '../../base-docs/detail/doc-conditions/doc-conditions.component';
import { DocClassificationsComponent } from '../../base-docs/detail/doc-classifications/doc-classifications.component';
import { DocCustomerAddressesComponent } from '../../base-docs/detail/doc-customer-addresses/doc-customer-addresses.component';
import { DocCustomerOthersComponent } from '../../base-docs/detail/doc-customer-others/doc-customer-others.component';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { DocSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-side-panel/doc-side-panel.component';
import {
  DocumentCoreCardComponent,
  DocumentCustomerCardComponent,
  DocumentCustomerDateCardComponent,
  DocumentCustomerStatusCardComponent,
} from '../../../components';
import { StockValidationSharedLogicService } from '../../stock-validation-shared-logics/stock-validation-shared-logic.service';
import { DocHierarchyService } from '../../../components/doc-hierarchy/doc-hierarchy-item.service';
import { CustomerInvoicePaymentsComponent } from '../../customer-invoices/customer-invoice-detail/customer-invoice-payments/customer-invoice-payments.component';
import { paymentsSidePanelTrigger } from '../../../components/side-panels/side.panel.utils';
import { DocPaymentSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-payment-side-panel/doc-payment-side-panel.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DocNumberTagComponent } from '../../../components/doc-number-tag/doc-number-tag.component';

@Component({
  selector: 'document-customer-delivery-note-detail',
  templateUrl: './customer-delivery-note-detail.component.html',
  styleUrl: './customer-delivery-note-detail.component.scss',
  providers: [DocTemplateService, StockValidationSharedLogicService],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    CustomerDeliveryNoteLinesEditorComponent,
    DocConditionsComponent,
    DocClassificationsComponent,
    DocCustomerAddressesComponent,
    DocCustomerOthersComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    DropdownMenuComponent,
    NgbNavOutlet,
    SidePanelComponent,
    FormsModule,
    DialogBoxComponent,
    ReportViewerComponent,
    LocalizationModule,
    CounterComponent,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DocSidePanelComponent,
    DocumentCoreCardComponent,
    DocumentCustomerCardComponent,
    DocumentCustomerDateCardComponent,
    DocumentCustomerStatusCardComponent,
    HistoryComponent,
    DocPaymentSidePanelComponent,
    NgSelectComponent,
    DwEnumSelectDirective,
    DocNumberTagComponent,
  ],
})
export class CustomerDeliveryNoteDetailComponent
  extends BaseCustomerDocDetail<
    CustomerDeliveryNoteService,
    CustomerDeliveryNoteDto,
    CreateUpdateCustomerDeliveryNoteDto,
    CustomerDocDefaultValueDto
  >
  implements OnInit, AfterViewInit
{
  @ViewChild('customerDeliveryNoteLineGrid') docLineGrid: CustomerDeliveryNoteLinesEditorComponent;
  @ViewChild('report') reportViewer: ReportViewerComponent;
  @ViewChild('payment') paymentPanel: SidePanelComponent;

  docRole = DocRole.CustomerDeliveryNote;
  fromPurchase: boolean = false;
  dayBook: DayBookDto;
  canAddPayment = signal(false);
  immediatePayment = signal(false);
  remainingAmount$: Observable<number>;

  currentCompanyStore = inject(CurrentCompanyStore);
  enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  contactEnumerationTypeStore = inject(GoliathContactsEnumerationTypeStore);
  coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  salesPersonStore = inject(SalesPersonStore);
  stockValidationSharedLogicService = inject(StockValidationSharedLogicService);
  signingService = inject(CustomerDeliveryNoteSigningService);

  private baseTriggers: PanelTrigger[] = [];
  private validateInProgress: boolean = false;

  protected get defaultPanel() {
    return this.immediatePayment() ? this.paymentPanel : this.infoPanel;
  }

  protected saveActionBtns = computed(() => {
    let btns = [
      {
        label: this.localizationService.instant('::Save'),
        action: () => this.save(),
        disabled: () =>
          this.isValidated() &&
          (!this.form.dirty || !this.stockValidationSharedLogicService.canSave()),
      },
    ];
    return btns;
  });

  actions: Signal<DropdownMenu> = computed(() => {
    const baseGroup = this.baseActionsThirdPartyDoc().concat(
      {
        label: '::GeneratePdf',
        icon: 'digi-out-pdf-file',
        action: () => this.generatePdf(this.reportViewer),
      },
      {
        label: 'Doc::PrintDocument',
        icon: 'digi-out-print',
        action: () => this.printDocument(),
        enabled: this.canPrintDocument,
      },
      {
        label: 'Doc::CustomerDeliveryNote:Sign',
        icon: 'digi-out-fluid-pencil',
        action: () => this.openSigning(),
        enabled: computed(() => {
          const entity = this.entitySignal();
          return entity?.isStockValidated && !entity?.signatureId;
        }),
      },
      {
        label: 'Doc::CustomerInvoice:AddPayment',
        icon: 'digi-out-payment-method',
        visible: computed(() => {
          return this.canAddPayment();
        }),
        action: () => this.addPayment(),
      },
      {
        label: 'Doc::DeliveryNote:ToCustomerInvoice',
        icon: 'digi-out-add-file',
        action: () => this.toCustomerInvoice(),
        enabled: computed(() => !this.entitySignal().isCancelled),
      },
    );
    baseGroup.push(
      {
        label: 'Doc::DeliveryNote:Cancel',
        icon: 'digi-out-arrow-back-circle',
        action: () => this.cancel(),
        enabled: computed(() => {
          // Document must be validated AND not invoiced AND not cancelled
          const doc = this.entitySignal();
          return (
            doc != null &&
            doc.isStockValidated &&
            doc.isInvoiced == InvoicedStatus.NotInvoiced &&
            !doc.isCancelled
          );
        }),
      },
      {
        label: 'Doc::DeliveryNote:Unblock',
        icon: 'digi-out-unlock',
        action: () => {
          this.confirmationService
            .warn('Doc::DeliveryNote:UnblockConfirmation', '::AreYouSure')
            .subscribeOnce(x => {
              if (x != Confirmation.Status.confirm) return;
              this.customerDeliveryNoteService
                .unblockLinesForEdit(this.docId)
                .subscribeOnce(() => this.getEntity(this.docId));
            });
        },
        enabled: computed(() => {
          const doc = this.entitySignal();
          return !doc.isUnblocked && doc.lines.some(x => !x.isEditable && x.sourceLineId != null);
        }),
        visible: computed(() =>
          this.permissionHelper.checkPermission(CustomerDeliveryNotePermission.Override),
        ),
      },
    );
    return {
      groups: [
        baseGroup,
        [
          {
            label: 'Doc::GenerateDocPrintTemplate',
            icon: 'digi-out-edit-square',
            action: () => this.openDesigner(),
            requiredPolicy: DocReportPermission.Create,
          },
        ],
      ],
    };
  });

  weightUnits = WeightUnit;
  totalAmount: number = 0;
  totalAmountVatIncluded: number = 0;

  override get defaultValue() {
    return Object.assign(this.baseDefaultValue, {
      isExported: false,
      allowPartialDelivery: false,
    });
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    private customerDeliveryNoteService: CustomerDeliveryNoteService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    injector: Injector,
    customerService: CustomerService,
    config: ConfigStateService,
    docTemplateService: DocTemplateService,
    classificationTypeService: ClassificationTypeService,
    protected pointOfSaleService: PointOfSaleService,
    confirmationService: ConfirmationService,
    private customerInvoiceService: CustomerInvoiceService,
    deactivableComponentService: DeactivatableComponentService,
    private docHierarchyService: DocHierarchyService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      customerDeliveryNoteService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      customerService,
      config,
      confirmationService,
      deactivableComponentService,
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.stockValidationSharedLogicService.setup({
      isCreationMode: this.isCreationMode,
      isValidated: this.isValidated,
      lineCount: this.lineCount,
      isStockValidated: this.isStockValidated,
    });
    this.init();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    this.baseTriggers = this.triggers();
  }

  override get formModel() {
    return Object.assign({}, super.formModel, {
      invoicingAddress_ThirdPartyAddressId: [null],
      deliveryDate: [null],
      deliveryNoteStatus: [null],
    });
  }

  private openSigning() {
    this.formStateService.checkDirtyForm(this.form, () => {
      this.signingService.requestSignature(this.entity.id).subscribeOnce(response => {
        const signingKey = response.result;
        const canvaRef = this.offcanvasService.open(
          CustomerDeliveryNoteSigningComponent,
          this.injector,
          {
            position: 'end',
            panelClass: 'w-sm-75 w-md-50 w-lg-30',
          },
        );

        (canvaRef.componentInstance as CustomerDeliveryNoteSigningComponent).signingKey.set(
          signingKey,
        );

        canvaRef.dismissed.subscribe(() => {
          this.getEntity(this.entity.id);
        });
      });
    });
  }

  addPayment() {
    if (this.form.get('isBlocked').value) {
      this.isBlockedError();
      return;
    }
    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.formStateService.checkDirtyForm(this.form, () => {
      const canvaRef = this.offcanvasService.open(CustomerInvoicePaymentsComponent, null, {
        position: 'end',
        panelClass: 'w-100 w-sm-75',
      });

      (canvaRef.componentInstance as CustomerInvoicePaymentsComponent).invoiceId = this.entity.id;
      (canvaRef.componentInstance as CustomerInvoicePaymentsComponent).service.set(
        this.customerDeliveryNoteService,
      );

      canvaRef.dismissed.subscribe(() => {
        this.getEntity(this.entity.id);
      });
    });
  }

  toCustomerInvoice() {
    if (this.form.get('isBlocked').value) {
      this.isBlockedError();
      return;
    }
    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.formStateService.checkDirtyForm(this.form, () => {
      const confirmationResult$ = this.customerInvoiceService
        .canCreateFromDeliveryNote(this.entity.id)
        .pipe(
          concatMap(canCreate => {
            if (canCreate) {
              return this.confirmationService.warn(
                'Doc::CustomerInvoice:FromDeliveryNote',
                '::AreYouSure',
              );
            }
            return of(null);
          }),
        );

      confirmationResult$.subscribe(result => {
        if (result == Confirmation.Status.confirm) {
          const canvaRef = this.offcanvasService.open(
            CustomerInvoiceCreationDialogComponent,
            null,
            {
              position: 'end',
              panelClass: 'w-100 w-sm-75 w-3xl-50 ',
            },
          );

          let customerInvoiceCreationDialog = canvaRef.componentInstance;

          customerInvoiceCreationDialog.deliveryNoteId = this.entity.id;

          (
            canvaRef.componentInstance as CustomerInvoiceCreationDialogComponent
          ).customerInvoiceCreated.subscribe((customerInvoice: CustomerInvoiceDto) => {
            this.router.navigate(['../../customer-invoices', customerInvoice.id], {
              relativeTo: this.route,
            });
          });
        }
      });
    });
  }

  private cancel() {
    const confirm$ = this.confirmationService.warn(
      this.localizationService.instant('Doc::CancelConfirmation'),
      'Doc::Cancel',
    );

    confirm$.subscribeOnce(status => {
      if (status == Confirmation.Status.confirm) {
        this.docService.cancel(this.entity.id).subscribeOnce(response => {
          this.toastService.success('Doc::CustomerInvoice:CancellationDone');
          this.router.navigate(
            [
              '../../',
              this.docHierarchyService.getRoute(DocRole.CustomerReturnNote),
              response.result,
            ],
            { relativeTo: this.route },
          );
        });
      }
    });
  }

  protected updateDiscount(): void {
    this.docService
      .updateDiscount(this.entity.id, this.form.get('discount').value)
      .subscribeOnce(() => {
        this.refreshEntity();
      });
  }

  getEntityCallback(): void {
    super.getEntityCallback();
    super.loadThirdParties(this.entity.isClosed);

    this.docLineGrid?.lineGrid?.grid?.grid?.api?.redrawRows();
  }

  protected createEntity(defaultValue) {
    defaultValue.isValidated = true;

    return defaultValue;
  }

  protected onHierarchyLoaded($event: DocHierarchyDto) {
    if ($event.previousDocs.findIndex(x => x.docRole == DocRole.CustomerSalesPurchase) > -1) {
      this.fromPurchase = true;
    }
  }

  protected override onThirdPartyChanged = (thirdPartyId: string): void => {
    super.onThirdPartyChanged(thirdPartyId);
    this.thirdPartyId$.next(thirdPartyId);
  };

  protected override getFieldMappings(): FieldMapping[] {
    return [
      ...super.getFieldMappings(),
      { formField: 'representativeCommision', customerField: 'representativeCommission' },
    ];
  }

  protected override async afterGetEntity(response: CustomerDeliveryNoteDto): Promise<void> {
    await super.afterGetEntity(response);
    this.subscribeToFormValueChanges();

    this.getRemainingAmount();

    this.dayBooks$.subscribe(dayBooks => {
      this.dayBook = dayBooks.find(x => x.id == this.entity?.dayBookId);
      this.canAddPayment.set(
        this.dayBook?.paymentDayBookId != null && this.dayBook?.refundDayBookId != null,
      );
      this.immediatePayment.set(this.canAddPayment() && this.dayBook?.isImmediatePayment);

      const setTriggers = this.immediatePayment()
        ? new Set([paymentsSidePanelTrigger(this.paymentPanel), ...this.baseTriggers])
        : new Set(this.baseTriggers);

      this.triggers.set(Array.from(setTriggers));
    });
  }

  protected onImmediatePaymentAdded(discount: any): void {
    if (discount != null && discount != this.form.get('discount')?.value) {
      this.form.get('discount').setValue(discount);
      this.updateDiscount();
    } else {
      this.getRemainingAmount();
      this.form.markAsPristine();
    }
  }

  protected getRemainingAmount() {
    this.customerDeliveryNoteService.getRemainingAmount(this.entity.id).subscribeOnce(remaining => {
      this.remainingAmount$ = of(remaining);
    });
  }
  protected override afterSave(): void {
    super.afterSave();
    if (this.validateInProgress) {
      this.docService.validateStock(this.entity.id).subscribeOnce(() => {
        this.validateInProgress = false;
        this.toastService.success('Doc::CustomerQuote:IsValidated');
        if (this.isValidated() && this.canAddPayment() && this.immediatePayment()) {
          this.addPayment();
        }
      });
    } else {
      this.refreshEntity();
      this.subscribeToFormValueChanges();
    }
  }

  protected validateStock() {
    this.validateInProgress = true;
    this.save();
  }

  public override canDeactivate = async () => {
    this.canDeactivateTitle = this.stockValidationSharedLogicService.getCanDeactivateTitle();
    return !this.form.dirty;
  };
}
